import ExclusionListRepository from '../../domain/repository/ExclusionListRepository';
import ExclusionListStore from '../../domain/store/ExclusionListStore';

export class ExclusionListUsecase {
  private exclusionListRepository: ExclusionListRepository;
  private exclusionListStore: ExclusionListStore;

  constructor({
    exclusionListRepository,
    exclusionListStore,
  }: {
    exclusionListRepository: ExclusionListRepository;
    exclusionListStore: ExclusionListStore;
  }) {
    this.exclusionListRepository = exclusionListRepository;
    this.exclusionListStore = exclusionListStore;
  }

  public async getExclusionLists() {
    const { exclusionListRepository, exclusionListStore } = this;
    await exclusionListStore.setLoading(true, '');
    const exclusionList = await exclusionListRepository.getExclusionLists();
    await exclusionListStore.setExclusionList(exclusionList);
    await exclusionListStore.setLoading(false, '');
  }

  public async toggleExclusionList(organizationId: string) {
    const { exclusionListRepository, exclusionListStore } = this;
    await exclusionListStore.setLoading(true, organizationId);
    const exclusionList = await exclusionListRepository.toggleExclusionList(organizationId);
    await exclusionListStore.setExclusionList(exclusionList);
    await exclusionListStore.setLoading(false, '');
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/application/usecase/ExclusionListUsecase.ts